import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetCaseOriginList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + 'CaseOrigin/GetAllCaseOriginList'), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const CreateNewCaseOrigin = async (caseOriginDet) => {
    //debugger;
    //console.log(JSON.stringify(caseOriginDet))
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `CaseOrigin/CreateNewCaseOrigin`, 
        JSON.stringify(caseOriginDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const ActivateDeActivateCaseOrigin = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `CaseOrigin/ActivateDeActivateCaseOrigin?caseOriginId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateCaseOrigin = async(caseOriginDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'CaseOrigin/UpdateCaseOrigin', 
        JSON.stringify(caseOriginDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}